<template>
    <div class="bg-white max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
            class="mx-auto grid max-w-2xl grid-cols-1 items-start gap-x-8 gap-y-16 px-4 py-12 sm:px-6 sm:py-24 lg:max-w-7xl lg:grid-cols-2 lg:px-8">
            <div class="grid-rows-1">
                <h2 class="font-display text-3xl text-ink-900 sm:text-4xl">
                    Courses to match your needs
                </h2>
                <p class="mt-4 text-ink-500">
                    You can choose from a variety of Arabic courses that suit your needs and interests. Whether you are
                    a beginner or an advanced learner, we have the right course for you. Our courses are designed to
                    help you learn Arabic in a fun and engaging way, with experienced teachers and interactive
                    materials.
                </p>

                <dl class="mt-16 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 sm:gap-y-16 lg:gap-x-8">
                    <a :href="`/courses/${course.slug}`" v-for="(course, index) in courses" :key="index" class="border-t border-gold-300 pt-4 transition-colors hover:border-primary-500">
                        <dt class="font-medium text-ink-900">{{ course.name }}</dt>
                        <dd class="mt-2 text-sm text-ink-500">{{ course.description.substring(0, 70) }}...</dd>
                    </a>
                    <a href="/courses" class="border-t border-gold-300 pt-4 transition-colors hover:border-primary-500">
                        <dt class="font-medium text-primary-700">See More</dt>
                        <dd class="mt-2 text-sm text-ink-500"></dd>
                    </a>
                </dl>
            </div>
            <div class="grid grid-cols-2 grid-rows-1 gap-4 sm:gap-6 lg:gap-8">
                <img v-for="(image, index) in images" :key="index" :src="image.src" :alt="image.alt"
                    class="rounded-2xl bg-ink-100 object-cover object-center h-full" />
            </div>
        </div>
    </div>
</template>

<script setup type="module">
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { onMounted } from 'vue';
import { ref } from 'vue';
import { getFeaturedProducts } from '@/services/productService';

const courses = ref([]);

const images = [
    {
        alt: 'Teache me Arabic',
        src: 'images/courses/quran.jpg',
    },
    {
        alt: 'Teache me Arabic',
        src: 'images/courses/tafl.jpg',
    },
    {
        alt: 'Teache me Arabic',
        src: 'images/courses/arabic.jpg',
    },
    {
        alt: 'Teache me Arabic',
        src: 'images/courses/islamic.jpg',
    },
];

onMounted(() => {
    getFeaturedProducts().then((response) => {
        courses.value = response.data;
    }).catch((error) => {
        console.error('Error fetching featured courses:', error);
    });
});
</script>
